import React from 'react'
import { Image as DatoImage } from 'react-datocms'

import NextImage from 'next/image'

import get from 'lodash/get'

type Props = {
  alt?: string
  height?: number
  width?: number
  lazy?: boolean
  layout?: 'fill' | 'responsive' | 'fixed' | 'raw' | 'intrinsic'
  image?: any
  pictureStyle?: any
  src?: string
  style?: any
  priority?: boolean
}

const Image = ({
  alt = 'Default image alt text',
  height,
  image,
  layout,
  lazy = false,
  pictureStyle,
  priority,
  src,
  style = { maxWidth: 'unset' },
  width,
}: Props) => {
  const responsiveImage = get(image, 'responsiveImage')
  const imageUrl = get(image, 'url') || image

  if (responsiveImage) {
    return (
      <DatoImage
        data={responsiveImage}
        // @ts-ignore
        lazyLoad={lazy}
        pictureStyle={pictureStyle}
        style={style}
      />
    )
  }

  if (imageUrl || src) {
    return (
      <NextImage
        alt={alt}
        height={height}
        layout={layout}
        priority={priority}
        src={imageUrl || src}
        style={style}
        width={width}
      />
    )
  }

  return null
}

export default Image
